<template>
  <div class="flex flex-row gap-x-2.5 mb-2 border-b border-neutral-200">
    <!-- Product image -->
    <router-link :to="link" class="size-[4.75rem] shrink-0 p-1" @click="$emit('linkClick', $event)">
      <VcImage
        :src="product.imgSrc"
        :alt="product.name"
        size-suffix="sm"
        class="size-full object-contain object-center"
        lazy
      />
    </router-link>

    <div class="flex flex-col justify-start overflow-hidden">
      <!-- Product title -->
      <router-link
        :to="link"
        class="line-clamp-2 h-8 shrink-0 text-sm font-extrabold leading-[1.05rem] text-[--link-color]"
        @click="$emit('linkClick', $event)"
      >
        {{ product.name }}
      </router-link>

      <!-- Product props -->
      <div class="grid grid-cols-[auto_1fr] overflow-hidden text-xs leading-[1.063rem]">
        <span class="pr-3.5 font-bold">{{ $t("common.labels.sku") }}</span>
        <span class="truncate">{{ product.code }}</span>

        <template v-if="isAuthenticated && product.sapStockStatus != 3">
          <span class="pr-3.5 font-bold">{{ $t("common.labels.price") }}</span>
          <VcItemPrice :properties="product.properties" :value="product.price" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getProductRoute } from "@/core/utilities";
import { useUser } from "@/shared/account";
import type { Product } from "@/core/api/graphql/types";
import type { RouteLocationRaw } from "vue-router";

defineEmits<IEmits>();

const props = defineProps<IProps>();

interface IEmits {
  (eventName: "linkClick", globalEvent: PointerEvent): void;
}

interface IProps {
  product: Product;
}

const { isAuthenticated } = useUser();

const link = computed<RouteLocationRaw>(() => getProductRoute(props.product.id, props.product.slug));
</script>
